import React from 'react'
import AboutUs from '../components/AboutUs'

function About() {
  return (
    <div>
      <AboutUs />
    </div>
  )
}

export default About